<template>
    <div>
        <select
            name="quantity"
            @change="updateQuantity($event.target.value)"
            id="quantityControl"
            :title="oneAvailable ? $t('Checkout.quantity.oneAvailable') : ''"
            class="pull-left custom-select"
            :disabled="oneAvailable"
			:aria-label="$t('Generic.number')"
        >
            <option
                v-for="amount in availableQuantity"
                :key="'quantity' + amount"
                :value="amount"
                :selected="selected == amount"
            >
                {{ amount }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'QuantitySelect',
    props: {
        availableQuantity: Number,
        selected: [Number, String]
    },
    computed: {
        oneAvailable() {
            return this.availableQuantity === 1;
        }
    },
    methods: {
        updateQuantity(valueString) {
            this.$emit('update:selected', +valueString);
        }
    },
    watch: {
        /*
            Important: works around cases when provided quantity (usually from the query string)
            is bigger than the possible one
             */
        availableQuantity: {
            handler(availableQuantity) {
                if (this.selected > availableQuantity) {
                    this.updateQuantity(availableQuantity);
                }
            },
            immediate: true
        }
    }
};
</script>

<style scoped lang="scss">
#quantityControl {
    border: 1px solid var(--border-color);
    width: 60px;
    border-radius: 5px;
    font-size: 20px;
    line-height: 22px;
    margin-right: 10px;
    display: block;
    height: calc(1.5em + 0.75rem + 6px);
    padding: 0.375rem 0.75rem;
    outline: none;
}
</style>
